import agendaApiConfig from "./agendaApiConfig";
import ManageStorage from 'src/shared/global/manageStorage';

const procedimientoService = {

    async getServicios() {

        let query =  {}; 

        // let clinica = ManageStorage.getValueFromStorage("clinica");
        // if(clinica != ''){
        //     if(clinica == "CHILLÁN"){
        //         if(process.env.REACT_APP_SERVICIO_CHILLAN_IMG != ""){
        //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CHILLAN_IMG;
        //         }                                   
        //     }else if(clinica == 'PUERTO MONTT'){                
        //         if(process.env.REACT_APP_SERVICIO_PTOMONTT_IMG != ""){
        //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_PTOMONTT_IMG;
        //         }
        //     }else if(clinica == 'CALAMA'){
        //         if(process.env.REACT_APP_SERVICIO_CALAMA_IMG != ""){
        //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CALAMA_IMG;
        //         }                
        //     }else if(clinica == 'LOS ÁNGELES'){
        //         if(process.env.REACT_APP_SERVICIO_LOSANGELES_IMG != ""){
        //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_LOSANGELES_IMG;
        //         }     
        //     }else if(clinica == 'CONCEPCIÓN'){
        //         if(process.env.REACT_APP_SERVICIO_CONCE_IMG != ""){
        //             query.SER_CODIGO = process.env.REACT_APP_SERVICIO_CONCE_IMG;
        //         }                  
        //     }
             
        // }  

        // return await agendaApiConfig.get(`/imagenologia/${codeExamen}/examen`, {
        //     params: {
        //         ...query
        //     }
        // });

        return await agendaApiConfig.get(`/agenda-servicio`);
    },
    async getProcedimientos(cod) {
        let query =  {}; 
        let clinica = ManageStorage.getValueFromStorage("clinica");
        if(clinica != ''){
            if(clinica == "CHILLÁN"){
                if(process.env.REACT_APP_SERVICIO_CHILLAN != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CHILLAN;
                }                                   
            }else if(clinica == 'PUERTO MONTT'){                
                if(process.env.REACT_APP_SERVICIO_PTOMONTT != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_PTOMONTT;
                }
            }else if(clinica == 'CALAMA'){
                if(process.env.REACT_APP_SERVICIO_CALAMA != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CALAMA;
                }                
            }else if(clinica == 'LOS ÁNGELES'){
                if(process.env.REACT_APP_SERVICIO_LOSANGELES != ""){
                    query.SER_CODIGO = "PLA"; //process.env.REACT_APP_SERVICIO_LOSANGELES;
                }     
            }else if(clinica == 'CONCEPCIÓN'){
                if(process.env.REACT_APP_SERVICIO_CONCE != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CONCE;
                }                  
            }else if(clinica == 'TALCA'){
                if(process.env.REACT_APP_SERVICIO_TALCA != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CONCE;
                }                  
            }else if(clinica == 'ANCUD'){
                if(process.env.REACT_APP_SERVICIO_ANCUD != ""){
                    query.SER_CODIGO = "PCD"; //process.env.REACT_APP_SERVICIO_CONCE;
                }                  
            }
             
        }  
        const response = await agendaApiConfig.get(`/agenda-procedimiento/${cod}`, {
            params: {
                ...query
            }
        });
        console.log("respuesta err001 => ", response.data, clinica, cod);
        
        return response;
    }

}

export default procedimientoService